module.exports = "https://static.wmbcdn.com/uniweb/images/524d037dcd1b97dd7095f830159e3292.jpg";